<template>
    <div id="contenedor-principal-permisos-pw" class="container-fluid">
         <div id="encabezados-tp">
            <h1>ADMINISTRACIÓN DE PERMISOS PAGINA WEB</h1>
            <h3>Asigna los permisos para el control de la pagina web</h3>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCION PRINCIPAL PARA PERMISOS -->
        <div class="row" style="margin-top:4em;">
            <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <!-- TIPO DE PERMISO -->
                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    <h6 for="estatus-resultado">Elige el tipo de permiso</h6>
                    <CCatalogoGenerico class="p-0 m-0" 
                        v-on:valorParaElPadre="evtCambioTipoPermiso" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="CtiposDePermisos.ID" 
                        :valorDefinido="CtiposDePermisos.valorDefinido"
                        :textoOpcionesSingular="''"
                        :textoOpcionesPlural="''"
                        :elementosCatalogo="CtiposDePermisos.opciones"
                        :conOpcionDeinstrucciones="CtiposDePermisos.mostrarSoloOpcionesValidas"
                        :key="CtiposDePermisos.KEY + CtiposDePermisos.contRender"></CCatalogoGenerico>
                </div>
            </div>
            <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                <div class="formulario no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-2">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4">
                        <h5><strong>Busqueda de usuarios</strong></h5>
                    </div>
                    <div class="row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4">
                        <form v-show="formularioUsuarios.mostrarFiltrosBusqueda" @submit="ejecutarProcesoBusquedaDeUsuarios($event)" class="filtros pt-4 pl-4 pb-2 pr-1 row no-gutters col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4">
                                <h6 class="form-inline" style="gap: 0.3em !important;"><i class="fas fa-filter"></i>Nombre</h6>
                                <input v-model="formularioUsuarios.nombre" type="text" class="form-control" placeholder="Ingrese el nombre del usuario" />
                            </div>
                            <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4">
                                <h6 class="form-inline" style="gap: 0.3em !important;"><i class="fas fa-filter"></i>Apellido paterno</h6>
                                <input v-model="formularioUsuarios.apellidoPaterno" type="text" class="form-control" placeholder="Ingrese el apellido paterno del usuario" />
                            </div>
                            <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4">
                                <h6 class="form-inline" style="gap: 0.3em !important;"><i class="fas fa-filter"></i>Apellido materno</h6>
                                <input v-model="formularioUsuarios.apellidoMaterno" type="text" class="form-control" placeholder="Ingrese el apellido materno del usuario" />
                            </div>
                            <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4">
                                <h6 class="form-inline" style="gap: 0.3em !important;"><i class="fas fa-filter"></i>correo</h6>
                                <input v-model="formularioUsuarios.correo" type="text" class="form-control" placeholder="Ingrese el correo del usuario" />
                            </div>
                            <div v-show="false" class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 align-self-end">
                                <button type="submit" class="btn btn-sm btn-light"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar usuario</button>
                            </div>
                        </form>
                    </div>
                    <!-- SELECCION DE USUARIOS -->
                    <div v-if="formularioUsuarios.tabla.visible" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4 pr-4">
                        <div class="tabla-VADPPW-intranet">
                            <div id="toolbar-tabla-usuarios">
                                <div class="form-inline flex-wrap mt-2" style="gap: 2em !important;">
                                    <h5 class="form-inline"><strong>Usuarios</strong>&nbsp;&nbsp;<span class="badge bg-primary rounded-pill">{{ getUsuariosSeleccionados.length }}</span></h5>
                                    <button v-if="mostrarModalAsignacionPermisos" @click="accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPPW', mostrar: true })" type="button" class="btn btn-sm btn-encabezado btn-dark"><i class="fas fa-plus"></i>&nbsp;&nbsp;Permisos</button>
                                </div>
                            </div>
                            <table
                                class="table table-striped table-light table-hover"
                                :id="formularioUsuarios.tabla.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-search-align="right"
                                data-toolbar="#toolbar-tabla-usuarios" 
                                data-toolbar-align="left"
                                data-undefined-text="Sin información" 
                                data-maintain-meta-data="true"
                                data-click-to-select="true"
                                data-page-size = "3"
                                data-page-list="[1, 2, 3 ,5,10,20,30]"
                                data-show-toggle="true"
                                data-show-pagination-switch="true"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado" data-formatter="deshabilitarSeleccionUsuarios"  data-checkbox="true"></th>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="IdUsuario" data-sortable="true">
                                            Id
                                        </th>
                                        <th data-halign="center" data-width="30" data-align="center" data-field="Nombre" data-sortable="true">
                                            Nombre
                                        </th>
                                        <th data-halign="center" data-width="20" data-align="center" data-field="NombreArea" data-sortable="true">
                                            Area
                                        </th>
                                        <th data-halign="center" data-width="15" data-align="center" data-field="NombrePuesto" data-sortable="true">
                                            Puesto
                                        </th>
                                            <th data-halign="center" data-width="15" data-align="center" data-events="operateEvents" data-field="accionHTML" data-sortable="true"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL LISTA TEMPORAL DE PERMISOS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-permisos-seccion-usuarios-VADPPW">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lista de permisos para guardar</h5>
                        <button  id="btn-cerrar-modal-permisos-seccion-usuarios-VADPPW" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 2em 2em 1em 2.5em !important;">
                        <div id="busqueda-secciones">
                            <div class="form-group no-gutters  pl-0 col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <h6 for="estatus-resultado">Elige el tipo de pagina</h6>
                                <CCatalogoGenerico class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioTipoPagina" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="asignacion.CPaginasWeb.ID" 
                                    :valorDefinido="asignacion.CPaginasWeb.valorDefinido"
                                    :textoOpcionesSingular="'Selecciona un tipo de página web'"
                                    :textoOpcionesPlural="''"
                                    :elementosCatalogo="asignacion.CPaginasWeb.opciones"
                                    :conOpcionDeinstrucciones="asignacion.CPaginasWeb.mostrarSoloOpcionesValidas"
                                    :key="asignacion.CPaginasWeb.KEY + asignacion.CPaginasWeb.contRender"></CCatalogoGenerico>
                            </div>
                            <div>
                                <div class="tabla-VADPPW-intranet">
                                    <div id="toolbar-tabla-secciones-pw">
                                        <div class="form-inline flex-wrap mt-2" style="gap: 2em !important;">
                                            <h5 class="form-inline"><strong>Secciones</strong>&nbsp;&nbsp;<span class="badge bg-primary rounded-pill">{{ getSeccionesSeleccionadas.length }}</span></h5>
                                            <button v-if="getSeccionesSeleccionadas.length > 0" @click="agrgearSeccionesAPermisosTemporales" type="button" class="btn btn-sm btn-encabezado btn-info"><i class="fas fa-plus"></i>&nbsp;&nbsp;Agregar</button>
                                        </div>
                                    </div>
                                    <table
                                        class="table table-striped table-light table-hover"
                                        :id="asignacion.secciones.tabla.ID"              
                                        data-toggle="table"
                                        data-pagination="true"
                                        data-search-align="right"
                                        data-toolbar="#toolbar-tabla-secciones-pw" 
                                        data-toolbar-align="left"
                                        data-undefined-text="Sin información" 
                                        data-maintain-meta-data="true"
                                        data-click-to-select="true"
                                        data-page-size = "3"
                                        data-page-list="[3, 5,10,20,30]"
                                        data-show-toggle="false"
                                        data-show-pagination-switch="false"
                                        data-search="true">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="seleccionado"  data-checkbox="true"></th>
                                                <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                                    Id
                                                </th>
                                                <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                                    Nombre
                                                </th>
                                                <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                                    Pertenece a
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- SECCION TEMPORAL DE SECCIONES AGREGADAS -->
                        <div v-if="getPermisosTemporales.length > 0">
                            <hr style="border: 1px solid rgb(66, 62, 62);"/>
                            <h5 class="mt-4"><strong>[ SECCIONES PARA ASIGNAR PERMISOS A LOS USUARIOS SELECCIONADOS ]</strong></h5>
                            <div class="tabla-VADPPW-intranet mt-4">
                                <div id="toolbar-tabla-secciones-asignacion-pw">
                                    <div class="form-inline flex-wrap mt-2" style="gap: 2em !important;">
                                        <h5 class="form-inline"><strong>Permisos</strong>&nbsp;&nbsp;<span class="badge bg-primary rounded-pill">{{ getPermisosTemporales.length }}</span></h5>
                                        <button type="button" @click="ejecutarProcesoNuevosPermisosUsuarioSecciones({ soloNuevos: true, usuariosId: formularioUsuarios.tabla.lista.filter(u => u.seleccionado).map(u => u.IdUsuario),  seccionesId: asignacion.permisos.tabla.lista.map(s => s.seccionId) })" class="btn btn-sm btn-encabezado btn-success"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                        <button type="button" @click="limpiarTabla({ idTabla: asignacion.permisos.tabla.ID })" class="btn btn-sm btn-encabezado btn-danger"><i class="fas fa-trash"></i>&nbsp;&nbsp;Remover todos</button>
                                    </div>
                                </div>
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="asignacion.permisos.tabla.ID"              
                                    data-toggle="table"
                                    data-pagination="true"
                                    data-search-align="right"
                                    data-toolbar="#toolbar-tabla-secciones-asignacion-pw" 
                                    data-toolbar-align="left"
                                    data-undefined-text="Sin información" 
                                    data-maintain-meta-data="true"
                                    data-click-to-select="true"
                                    data-page-size = "3"
                                    data-page-list="[3, 5,10,20,30]"
                                    data-show-toggle="false"
                                    data-show-pagination-switch="false"
                                    data-search="true">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                                Id
                                            </th>
                                            <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                                Nombre
                                            </th>
                                            <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                                Pertenece a
                                            </th>
                                            <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="eliminarHTML" data-sortable="true"></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL EDICON DE SECCIONES USUARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-edicion-secciones-usr-VADPPW">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lista de permisos con secciones de usuario</h5>
                        <button  id="btn-cerrar-modal-edicion-secciones-usr-VADPPW" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body" style="padding: 2em 2em 1em 2.5em !important;">
                        <div class="tabla-VADPPW-intranet">
                            <div id="toolbar-tabla-edicion-secciones-usr">
                                <div class="form-inline flex-wrap" style="gap: 1em !important;">
                                    <button type="button" @click="guardarCambiosSeccionesDeUsuario({ idModalDondeSeEjecuta: 'modal-edicion-secciones-usr-VADPPW' })" class="btn btn-sm btn-info">
                                        <i class="fas fa-save"></i>&nbsp;&nbsp;Guardar
                                    </button>
                                    <button type="button" @click="accionEnModal({ idModal: 'modal-edicion-secciones-usr-VADPPW', mostrar: false}, accionEnModal({ idModal: 'modal-confirmar-remover-seccion-usr-VADPPW', mostrar: true}))" class="btn btn-sm btn-danger">
                                        <i class="fas fa-trash"></i>&nbsp;&nbsp;Remover todos
                                    </button>
                                </div>
                            </div>
                            <table
                                class="table table-striped table-light table-hover"
                                :id="formularioUsuarios.tablaSeccionesUsuario.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-search-align="right"
                                 data-toolbar="#toolbar-tabla-edicion-secciones-usr" 
                                data-toolbar-align="left"
                                data-undefined-text="Sin información" 
                                data-maintain-meta-data="true"
                                data-click-to-select="true"
                                data-page-size = "5"
                                data-page-list="[5,10,20,30]"
                                data-show-toggle="false"
                                data-show-pagination-switch="false"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="seccionId" data-sortable="true">
                                            Id
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="nombre" data-sortable="true">
                                            Nombre
                                        </th>
                                        <th data-halign="center" data-width="40" data-align="center" data-field="perteneceA" data-sortable="true">
                                            Pertenece a
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-events="operateEvents" data-field="eliminarHTML" data-sortable="true"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL CONFRIMAR QUITAR TODAS LAS SECCIONES A USUARIO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmar-remover-seccion-usr-VADPPW">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>
                                Se eliminaran todas los permisos para subir contenido en las secciones del usuario,<br>
                                ¿Deseas continuar?
                            </h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="guardarCambiosSeccionesDeUsuario({ idModalDondeSeEjecuta: 'modal-confirmar-remover-seccion-usr-VADPPW', eliminarTodos: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="accionEnModal({ idModal: 'modal-confirmar-remover-seccion-usr-VADPPW', mostrar: false}), accionEnModal({ idModal: 'modal-edicion-secciones-usr-VADPPW', mostrar: true})"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import sistemas from '@/../static/js/sistemas'
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import { campoEsValido } from "../../../SINOJ/Comun/Funciones/validaciones.js"
import axios from 'axios';
import api from '@/../static/js/api';
import comun from '@/../static/js/comun';
import { servicioRestPost } from '../../../SINOJ/Comun/ServiciosRest/servicios.js'

export default {
    components: {
        CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico
    },
    data() {
        return {
            enumeraciones,
            campoEsValido,
            servicioRestPost,
            CtiposDePermisos: {
                TIPOS: { PAGINAS: 1, SECCIONES: 2 },
                ID: 'CTiposDePermisos_VADPPW',
                KEY: 'KEY_TiposDePermisos_VADPPW',
                valorDefinido: 1,
                opciones: [ { llave: 1, valor: 'permisos para subir contenido en secciones' } ],
                mostrarSoloOpcionesValidas: false,
                contRender: 0,
                seleccionado: { llave: 1, valor: 'permisos para subir contenido en secciones' }
            },
            formularioUsuarios: {
                nombre: null,
                apellidoPaterno: null,
                apellidoMaterno: null,
                correo: null,
                mostrarFiltrosBusqueda: true,
                tabla: {
                    visible: false,
                    ID: 'TPUsuarios_VADPPW',
                    lista: []
                },
                tablaSeccionesUsuario: {
                    visible: false,
                    ID: 'TSeccionesDeUsuario_VADPPW',
                    lista: [],
                    seleccionado: null
                }
            },
            asignacion: {
                CPaginasWeb: {
                    ID: 'CTiposDePaginaWeb_VADPPW',
                    KEY: 'KEY_TiposDePaginaWeb_VADPPW',
                    valorDefinido: -1,
                    opciones: [],
                    mostrarSoloOpcionesValidas: true,
                    contRender: 0,
                    seleccionado: null
                },
                secciones: {
                    tabla: {
                        visible: false,
                        ID: 'TSecciones_VADPPW',
                        lista: []
                    }
                },
                permisos: {
                    tabla: {
                        visible: false,
                        ID: 'TSeccionesPermisosTmp_VADPPW',
                        lista: []
                    }
                }
            }
        }
    },
    methods: {
        guardarCambiosSeccionesDeUsuario: function({ idModalDondeSeEjecuta, eliminarTodos = false }) {
            this.accionEnModal({ 
                idModal: idModalDondeSeEjecuta, 
                mostrar: false
            });
            this.ejecutarProcesoNuevosPermisosUsuarioSecciones({ 
                soloNuevos: false, 
                usuariosId: [this.formularioUsuarios.tablaSeccionesUsuario.seleccionado.IdUsuario], 
                seccionesId: eliminarTodos ? [] : this.formularioUsuarios.tablaSeccionesUsuario.lista.map(s => s.seccionId) 
            });
        },
        ejecutarProcesoNuevosPermisosUsuarioSecciones: async function({ soloNuevos, usuariosId, seccionesId }) {
            try {
                if(soloNuevos) {
                    this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPPW', mostrar: false })
                }
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GUARDAR_PERMISOS = {
                    IdSecciones: seccionesId,
                    SoloNuevos: soloNuevos,
                    UsuariosId: usuariosId,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { CON_ERROR, RESPUESTA: { IdSecciones, Satisfactorio } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.SICPO.sistema.paginaweb.permisos.GuardarSeccionesUsuarios,
                    peticionServicio: P_GUARDAR_PERMISOS,
                    headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    comun.mensajeDeAlerta(Satisfactorio);
                    if(soloNuevos) {
                        this.limpiarModalAsigancionPermisos();
                    }
                }
                else {
                    if(soloNuevos) {
                        this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPPW', mostrar: true })
                    }
                }
            }
            catch(error) {
                console.error();
            }
        },
        limpiarModalAsigancionPermisos: async function() {
            await Promise.resolve(this.inicializarCatalogoPaginasWeb({ opcionSleccionada: -1 }));
            this.asignacion.secciones.tabla.lista = [];
            await Promise.resolve(this.inicializarTabla({ idReferencia: this.asignacion.secciones.tabla.ID, elementos: [] }));
            this.asignacion.permisos.tabla.lista = [];
            await Promise.resolve(this.inicializarTabla({ idReferencia: this.asignacion.permisos.tabla.ID, elementos: [] }));
        },
        ejectuarProcesoGetSeccionesUsuario: async function({ usuario }) {
            try {
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GET_SECCIONES = {
                    UsuarioId: usuario.IdUsuario,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { CON_ERROR, RESPUESTA: { Secciones } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.SICPO.sistema.paginaweb.permisos.ObtenerSeccionesDeUsuario,
                    peticionServicio: P_GET_SECCIONES,
                    headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    if(!campoEsValido({ campoAValidar: Secciones })) {
                        comun.mensajeDeAlerta('El usuario no tiene ningun permiso especial con alguna de las secciones de la pagina web');
                    }
                    else {
                        // se actualizan las filas de los usuarios modificados
                        this.formularioUsuarios.tablaSeccionesUsuario.lista = Secciones.map(sDB => {
                            let seccionObj = { ...sDB };
                            seccionObj.eliminarHTML = `<button type="button" title="eliminar seccion de la lista" class="btn btn-sm btn-removerSeccion-VADPPW btn-danger">
                                                            <i class="fas fa-trash"></i>
                                                        </button>`
                            return seccionObj;
                        });
                        this.accionEnModal({ 
                            idModal: 'modal-edicion-secciones-usr-VADPPW', 
                            mostrar: true, cargarTabla : { idTabla: this.formularioUsuarios.tablaSeccionesUsuario.ID, elementos: this.formularioUsuarios.tablaSeccionesUsuario.lista } 
                        });
                    }
                }
            }
            catch(error) {
                console.error();
            }
        },
        ejecutarProcesoGuardarPermisosAPlataformaSICPO: async function({ usuarios, activar }) {
            try {
                // se crea la peticion para guardar los nuevos permisos entre secciones y usuarios
                const P_GUARDAR_PERMISOS = {
                    UsuariosId: usuarios,
                    Activar: activar,
                    EsPrueba: false
                };

                // se llama al servicio para guardar los permisos
                const { CON_ERROR, RESPUESTA: { Satisfactorio } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.SICPO.sistema.paginaweb.permisos.GuardarPermisosAPlataformaSICPO,
                    peticionServicio: P_GUARDAR_PERMISOS,
                    headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));
                console.log('CON_ERROR::',CON_ERROR)

                if(!CON_ERROR) {
                    // se actualizan las filas de los usuarios modificados
                    usuarios.forEach(idUsuario => { debugger
                        let usuarioActualizado = this.formularioUsuarios.tabla.lista.find(u => u.IdUsuario == idUsuario);
                        usuarioActualizado.TienePermisosEnIntranet = activar;
                        usuarioActualizado.habilitado = usuarioActualizado.TienePermisosEnIntranet;
                        usuarioActualizado.accionHTML = (!usuarioActualizado.TienePermisosEnIntranet) 
                            ? `<button type="button" title="Dar permiso a plataforma de intranet" class="btn btn-sm btn-usr-agregarASICPO-VADPPW btn-success">
                                 <i class="fas fa-plus"></i>
                               </button>`
                            : `<div class="d-flex flex-wrap justify-content-center" style="gap: 1em !important;">
                                    <button type="button" title="Editar permisos con secciones plataforma de intranet" class="btn btn-sm btn-usr-verPermisosSecciones-VADPI btn-warning">
                                        <i class="fas fa-key"></i>
                                    </button>
                                    <button type="button" title="remover permiso a plataforma de intranet" class="btn btn-sm btn-usr-removerSICPO-VADPPW btn-danger">
                                        <i class="fas fa-trash"></i>
                                    </button>
                               </div>`;
                        $("#" + this.formularioUsuarios.tabla.ID).bootstrapTable('updateByUniqueId', {
                            id: usuarioActualizado.IdUsuario,
                            row: usuarioActualizado
                        });
                    });
                    comun.mensajeDeAlerta(Satisfactorio);
                }
            }
            catch(error) {
                console.error(error);
            }
        },
        limpiarTabla: async function({ idTabla }) {
            this.asignacion.permisos.tabla.lista = [];
            await Promise.resolve(this.inicializarTabla({ idReferencia: idTabla, elementos: this.asignacion.permisos.tabla.lista }));
        },
        removerElementoDeLista: function({ idTabla, elemento, eliminarPor }) {
            $("#" + idTabla).bootstrapTable('remove', {
                field: eliminarPor,
                values: [elemento[eliminarPor]]
            });
        },
        agrgearSeccionesAPermisosTemporales: async function() {
            this.getSeccionesSeleccionadas.forEach(s => {
                let seccionYaFueAgregada = this.asignacion.permisos.tabla.lista.some(p => p.seccionId == s.seccionId);
                if(!seccionYaFueAgregada) {
                    let seccionTmp = { ...s };
                    seccionTmp.eliminarHTML = `<button type="button" title="eliminar seccion de la lista" class="btn btn-sm btn-removerSeccionDeUsuario-VADPPW btn-danger">
                                                    <i class="fas fa-trash"></i>
                                                </button>`
                    this.asignacion.permisos.tabla.lista.push(seccionTmp);
                }
            });
            await Promise.resolve(this.inicializarTabla({ idReferencia: this.asignacion.permisos.tabla.ID, elementos: this.asignacion.permisos.tabla.lista }));

            // se quita la seleccion de la tabla de secciones principales
            this.asignacion.secciones.tabla.lista = this.asignacion.secciones.tabla.lista.map(s => {
                s.seleccionado = false;
                return s;
            });
            await Promise.resolve(this.inicializarTabla({ idReferencia: this.asignacion.secciones.tabla.ID, elementos: this.asignacion.secciones.tabla.lista }));
        },
        evtCambioTipoPagina: async function(evento) {
            try {
                await Promise.resolve(this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPPW', mostrar: false }));
                const { ID } = this.asignacion.secciones.tabla;
                let paginaSeleccionada = campoEsValido({ campoAValidar: evento.target.value });
                this.asignacion.CPaginasWeb.valorDefinido = paginaSeleccionada ? parseInt(evento.target.value) : 1;
                this.asignacion.CPaginasWeb.seleccionado = this.asignacion.CPaginasWeb.opciones.find(o => o.llave == this.asignacion.CPaginasWeb.valorDefinido);
                if(paginaSeleccionada) {
                    // se realiza la busqueda de secciones de la pagina
                    const P_GET_SECCIONES = {
                        PaginaId: this.asignacion.CPaginasWeb.valorDefinido,
                        EsPrueba: false
                    };
                    const { CON_ERROR, RESPUESTA: { Secciones } }  = await Promise.resolve(servicioRestPost({
                        servicioUrl: api.SICPO.sistema.paginaweb.permisos.ObtenerSecciones,
                        peticionServicio: P_GET_SECCIONES,
                        headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                    }));

                    if(!CON_ERROR) {
                        this.asignacion.secciones.tabla.lista = campoEsValido({ campoAValidar: Secciones }) 
                            ? Secciones.map(sDB => {
                                let seccionObj = { ...sDB };
                                seccionObj.seleccionado = false;
                                return seccionObj;
                            }) : [];
                    }
                    else {
                        this.asignacion.secciones.tabla.lista = [];
                    }
                }
                await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.asignacion.secciones.tabla.lista }));
                await Promise.resolve(this.accionEnModal({ idModal: 'modal-permisos-seccion-usuarios-VADPPW', mostrar: true }));
            }
            catch(err) {
                console.error('err::gSpw::',err);
            }
        },
        accionEnModal: async function({ idModal, mostrar, cargarTabla = { idTabla: '', elementos: [] }}) {
            let instruccion = mostrar ? 'show' : 'hide';
            $("#" + idModal).modal(instruccion);

            if(campoEsValido({ campoAValidar: cargarTabla.idTabla })) {
                await Promise.resolve(this.inicializarTabla({ idReferencia: cargarTabla.idTabla, elementos: cargarTabla.elementos }));
            }
        },
        ejecutarProcesoBusquedaDeUsuarios: async function(evento) { debugger
            evento.preventDefault();
            try {
                const { nombre, apellidoPaterno, apellidoMaterno, correo } = this.formularioUsuarios;
                const P_GET_USUARIOS = {
                    Nombre: campoEsValido({ campoAValidar: nombre }) ? nombre : null,
                    ApellidoPaterno: campoEsValido({ campoAValidar: apellidoPaterno }) ? apellidoPaterno : null,
                    ApellidoMaterno: campoEsValido({ campoAValidar: apellidoMaterno }) ? apellidoMaterno : null,
                    Correo: campoEsValido({ campoAValidar: correo }) ? correo : null,
                    EsPrueba: false
                };
                const { CON_ERROR, RESPUESTA: { Usuarios } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.SICPO.sistema.paginaweb.permisos.ObtenerUsuarios,
                    peticionServicio: P_GET_USUARIOS,
                    headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

                if(!CON_ERROR) {
                    const { ID } = this.formularioUsuarios.tabla;
                    this.formularioUsuarios.tabla.lista = campoEsValido({ campoAValidar: Usuarios }) 
                    ? Usuarios.map(uDB => {
                        let usuarioObj = { ...uDB };
                        usuarioObj.seleccionado = (Usuarios.length == 1 && uDB.TienePermisosEnIntranet);
                        usuarioObj.habilitado = uDB.TienePermisosEnIntranet;
                        usuarioObj.accionHTML = (!uDB.TienePermisosEnIntranet) 
                            ? `<button type="button" title="Dar permiso a SICPO" class="btn btn-sm btn-usr-agregarASICPO-VADPPW btn-success">
                                 <i class="fas fa-plus"></i>
                               </button>`
                            : `<div class="d-flex flex-wrap justify-content-center" style="gap: 1em !important;">
                                    <button type="button" title="Editar permisos para subir contendio en secciones" class="btn btn-sm btn-usr-verPermisosSecciones-VADPI btn-warning">
                                        <i class="fas fa-key"></i>
                                    </button>
                                    <button type="button" title="remover permiso a SICPO" class="btn btn-sm btn-usr-removerSICPO-VADPPW btn-danger">
                                        <i class="fas fa-trash"></i>
                                    </button>
                               </div>`;
                        return usuarioObj;
                    }) : [];
                    this.formularioUsuarios.tabla.visible = true;
                    await Promise.resolve(this.inicializarTabla({ idReferencia: ID, elementos: this.formularioUsuarios.tabla.lista }));
                }
            }
            catch(error) {
                console.error('Er::BqU::',error);
            }
        },
        evtCambioTipoPermiso: function(evento) { 
            this.CtiposDePermisos.valorDefinido = campoEsValido({ campoAValidar: evento.target.value }) ? parseInt(evento.target.value) : 1;
            this.CtiposDePermisos.seleccionado = this.CtiposDePermisos.opciones.find(o => o.llave == this.CtiposDePermisos.valorDefinido);
        },
        inicializarCatalogoPaginasWeb: async function({ opcionSleccionada }) {
            await Promise.resolve(this.getPaginasWeb());
            this.asignacion.CPaginasWeb.valorDefinido = opcionSleccionada;
            this.asignacion.CPaginasWeb.contRender ++;
        },
        getPaginasWeb: async function(peticion = null) {
            try {
                const P_GET_PAGINAS = campoEsValido({ campoAValidar: peticion }) 
                    ? peticion
                    : { EsPrueba: false, PaginaDeInicioId: null, MenuId: null, SubmenuId: null, TipoContenedorId: null, ConPaginaDeInicio: false, ConMenu: false, ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true, ConOrdenamientoAlfabetico: true };
                const { RESPUESTA: { PaginasWeb } }  = await Promise.resolve(servicioRestPost({
                    servicioUrl: api.SICPO.catalogos.C007PaginasWeb,
                    peticionServicio: P_GET_PAGINAS,
                    headers: { TOKEN_AUTORIZACION: this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));
                this.asignacion.CPaginasWeb.opciones = campoEsValido({ campoAValidar: PaginasWeb })
                    ? PaginasWeb.map(pwDB => {
                        let opcionObj = {};
                        opcionObj.llave = pwDB.PaginaWebId;
                        opcionObj.valor = pwDB.Titulo;
                        return opcionObj;
                    }) : [];
            }
            catch(error) {
                console.error('err::gPw::',error);
            }
        },
        inicializarTabla: async function({ idReferencia, elementos, callbackCheck = () => {} }) { 
            this.$nextTick(() => {
                $("#" + idReferencia).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $("#" + idReferencia).bootstrapTable({  data: elementos });      
                $("#" + idReferencia).bootstrapTable('load', elementos ); 
                $("#" + idReferencia).on('check.bs.table',(e, row) => {
                    /* this.evtContenidoSeleccionado({ contenido: row }); */
                    callbackCheck();
                });
                $("#" + idReferencia).on('uncheck.bs.table',(e, row) => {
                    callbackCheck();
                });
                $("#" + idReferencia).on('check-all.bs.table',(e, rows) => {
                    callbackCheck();
                });
                $("#" + idReferencia).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    callbackCheck();
                });
            });
        },
    },
    async mounted() {
         window.operateEvents = {
            'click .btn-usr-agregarASICPO-VADPPW': (e, value, row, index) => { 
                this.ejecutarProcesoGuardarPermisosAPlataformaSICPO({ usuarios: [row.IdUsuario], activar: true });
            },
            'click .btn-usr-removerSICPO-VADPPW': (e, value, row, index) => { 
                this.ejecutarProcesoGuardarPermisosAPlataformaSICPO({ usuarios: [row.IdUsuario], activar: false });
            },
            'click .btn-removerSeccion-VADPPW': (e, value, row, index) => { 
                const { ID } = this.formularioUsuarios.tablaSeccionesUsuario;
                this.removerElementoDeLista({ idTabla: ID, elemento: row, eliminarPor: 'seccionId' });
            },
            'click .btn-usr-verPermisosSecciones-VADPI': (e, value, row, index) => { 
                this.formularioUsuarios.tablaSeccionesUsuario.seleccionado = row;
                this.ejectuarProcesoGetSeccionesUsuario({ usuario: row });
            },
            'click .btn-removerSeccionDeUsuario-VADPPW': (e, value, row, index) => { 
                const { ID } = this.asignacion.permisos.tabla;
                this.removerElementoDeLista({ idTabla: ID, elemento: row, eliminarPor: 'seccionId' });
            }
        };
        this.formularioUsuarios.tabla.visible = true;
        await Promise.resolve(this.inicializarTabla({ idReferencia: this.formularioUsuarios.tabla.ID, elementos: [] }));
        await Promise.resolve(this.inicializarCatalogoPaginasWeb({ opcionSleccionada: -1 }));
        await Promise.resolve(this.inicializarTabla({ idReferencia: this.asignacion.secciones.tabla.ID, elementos: [] }));
    },
    computed: {
        mostrarModalAsignacionPermisos() {
            return this.formularioUsuarios.tabla.lista.some(u => u.seleccionado)
        },
        getUsuariosSeleccionados() {
            return this.formularioUsuarios.tabla.lista.filter(u => u.seleccionado)
        },
        getSeccionesSeleccionadas() {
            return this.asignacion.secciones.tabla.lista.filter(s => s.seleccionado)
        },
        getPermisosTemporales() {
            return this.asignacion.permisos.tabla.lista;
        }
    }
}
</script>
<style scoped>
#modal-permisos-seccion-usuarios-VADPPW .modal-lg {
    max-width: 60% !important;
}

#modal-permisos-seccion-usuarios-VADPPW .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-edicion-secciones-usr-VADPPW .modal-lg {
    max-width: 40% !important;
}

#modal-edicion-secciones-usr-VADPPW .modal-header {
    /* background-color: rgb(80, 80, 80); */
    background-color: rgb(15, 15, 15);
    border: none;
}

#modal-confirmar-remover-seccion-usr-VADPPW .modal-lg {
    max-width: 30% !important;
}

#modal-confirmar-remover-seccion-usr-VADPPW .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmar-remover-seccion-usr-VADPPW .modal-dialog {
    position: relative;
    top: 40%;
    transform: translateY(-50%);
}

.filtros {
    background-color: #2e2e2e;
    border-radius: 6px;
}

.formulario {
    border: 1.3px solid rgb(66, 62, 62);
    border-radius: 4px;
    padding: 1.8em 1em 1em 1.5em;
}

#encabezados-tp {
    margin-bottom: 1em;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados-tp h3 {
    font-size: 2em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}
</style>
<style>
.tabla-VADPPW-intranet .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.tabla-VADPPW-intranet .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.tabla-VADPPW-intranet td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
    font-weight: bold;
}

.tabla-VADPPW-intranet .borderless td, .tabla-VADPPW-intranet .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.tabla-VADPPW-intranet .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}


.tabla-VADPPW-intranet .btn-edt-cont-intr:hover, .tabla-VADPPW-intranet .btn-edt-cont-intr:focus {
    background-color: #009bca;
    border: 1px solid #009bca;
    color: white;
}

.tabla-VADPPW-intranet .btn-rmv-cont-intr:hover, .tabla-VADPPW-intranet .btn-rmv-cont-intr:focus {
    background-color: #810000;
    border: 1px solid #810000;
    color: white;
}

.tabla-VADPPW-intranet table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.tabla-VADPPW-intranet .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.tabla-VADPPW-intranet .pagination > li > a {
    background-color: white;
    color: #121213;
}

.tabla-VADPPW-intranet .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.tabla-VADPPW-intranet > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
} 

</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/Permisos/CPermisos.vue